module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "db mt5-ns centered-container-ns inter lh-copy"
  }, [_c('div', {
    staticClass: "shadow-theme-ns ph4-ns pv4-ns"
  }, [_c('center', [_c('svg', {
    staticClass: "feather feather-check",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "48",
      "height": "48",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "#3dbf00",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "f3 lh-copy cera-round-pro-bold tc-ns"
  }, [_vm._v("New plan added successfully!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', _vm._l((_vm.addedPlans), function(plan) {
    return _c('div', {
      key: plan.coverage.id,
      staticClass: "flex items-center"
    }, [_c('svg', {
      staticClass: "feather feather-smartphone",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('rect', {
      attrs: {
        "x": "5",
        "y": "2",
        "width": "14",
        "height": "20",
        "rx": "2",
        "ry": "2"
      }
    }), _c('line', {
      attrs: {
        "x1": "12",
        "y1": "18",
        "x2": "12.01",
        "y2": "18"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "mh2 cera-round-pro"
    }, [_c('strong', [_vm._v(_vm._s(plan.phoneNumber))]), _vm._v(" - " + _vm._s(plan.coverage.name))]), _vm._v(" "), (_vm.addedPlans && _vm.addedPlans.length > 1) ? _c('div', [_c('br'), _vm._v(" "), _c('br')]) : _vm._e()])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mv4 tc"
  }, [_vm._v("\n    If you have any questions or need help completing your registration, don't hesitate to reach out to us via the links below!\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mv4 flex justify-around"
  }, [_c('ak-button', {
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToSupportPage.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Support\n    ")]), _vm._v(" "), _c('ak-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.returnToAccountPage.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Return to Account\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center"
  }, [_c('span', {
    staticClass: "f4 cera-round-pro-bold"
  }, [_vm._v("Next Steps:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('span', {
    staticClass: "inter"
  }, [_vm._v("Please follow the instructions sent via SMS to the new device. "), _c('strong', [_vm._v("New lines must log in to complete activation separately for coverage to be in effect.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018454b9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/add-plan/PlanAddedConfirmation.vue
// module id = 1551
// module chunks = 0